import { BarChartProps } from "../../interfaces";
import { FlowerFull } from "../flowerFull";
import { BarChartContainer } from "./style";

export const BarChart: React.FC<BarChartProps> = ({ value }) => {
  
  return (
    <BarChartContainer>
      <FlowerFull value={value} />
      <span>{value.posicao}°</span>
    </BarChartContainer>
  );
};
